export const DATE_TYPE = {
  day: 'day',
  month: 'month',
};
